module.exports = __webpack_public_path__ + "img/image-question-builder.9b519d8a.jpg";